/* eslint-disable */

import csf from '../ext/buildV63';

const $window = $(window);
const $document = $(document);
const tracking = {};
let pageMeta = {};
let ruid = '';
let pvid = '';
let displayEventClient = {};
let purchaseEventClient = [];

function isEmptyObject(object) {
  return Object.keys(object).length === 0;
}

/**
 * frontends/web/ridibooks 의 이벤트 과 통일 작업
 * @param {string} event
 * @param {string | undefined} screen
 * @param {string | undefined} target
 * @returns event_name
 */
function getEventName(event, screen, target) {
  const prefix = screen ? `${screen}_` : '';
  const postfix = target ? `_${target}` : '';
  return `${prefix}${event}${postfix}`;
}

function sendToEventClient({ eventName, params, ga4Params }) {
  try {
    const { ridiEventClient } = window;
    if (ridiEventClient) {
      let data = {};
      let item = {};
      switch (eventName) {
        case 'display':
          item = { 'id': params.obj_id, 'idx': params.idx };
          if (params.rcmd_id !== '') {
            item.misc = { 'rcmd_id': params.rcmd_id };
          }
          if (displayEventClient.hasOwnProperty(params.section)) {
            displayEventClient[params.section].push(item);
          } else {
            displayEventClient[params.section] = [item];
          }
          if (params.is_last) {
            data = { 'section': params.section_full, 'items': displayEventClient[params.section] };
            delete displayEventClient[params.section];
            ridiEventClient.sendCustomEvent(eventName, data);
          }
          break;
        case 'click':
          item = { 'id': params.obj_id, 'idx': params.idx };
          if (params.rcmd_id !== '') {
            item.misc = { 'rcmd_id': params.rcmd_id };
          }
          data = { 'section': params.section_full, 'items': [item] };
          ridiEventClient.sendCustomEvent(eventName, data);
          break;
        case 'purchase_book':
          purchaseEventClient.push({ 'id': params.id, 'price': params.price, 'quantity': params.quantity });
          break;
        case 'transaction':
          data = { 't_id': params.id, 'revenue': params.revenue, 'items': purchaseEventClient };
          ridiEventClient.sendCustomEvent('purchase', data);
          purchaseEventClient = [];
          break;
        case 'page_unload':
          for (let key in displayEventClient) {
            data = { 'section': key, 'items': displayEventClient[key] };
            ridiEventClient.sendCustomEvent('display', data);
          }
          break;
        case 'view':
        case 'select': {
          if (isEmptyObject(ga4Params)) {
            break;
          }
          const { screen, target, ...rest } = ga4Params;
          const customEventName = getEventName(eventName, screen, target);
          ridiEventClient.sendCustomEvent(customEventName, rest);
          break;
        }
        default:
          break;
      }
    } else {
      throw new Error('not initialized event client')
    }
  } catch (e) { /** ignore */ }
}


// initialize
tracking.init = function () {
  // Facebook
  // Init 는 GTM 에서 함. 타이밍에 따른 fallback 처리
  if (typeof fbq === 'undefined') {
    !(function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod(...arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', '//connect.facebook.net/en_US/fbevents.js'));
  }

  tracking.fbq_wrap = (...args) => {
    const white_list = [
      '/account/login',
      '/account/signup',
      '/account/signup/form',
      '/account/send-verification-email'
    ];

    const black_list = [
      '/device/guarantee_device_registered',
      '/device/replace',
      '/freebook_inapp/index',
      '/review/view',
      '/library/purchased',
      '/account/'
    ];

    // white_list takes precedence over black_list
    if (white_list.some(row => window.location.pathname.includes(row)) || !black_list.some(row => window.location.pathname.includes(row))) {
      fbq(...args);
    }
  };

  // Twitter
  !(function (e, t, n, s, u, a) { e.twq || (s = e.twq = function () { s.exe ? s.exe(...arguments) : s.queue.push(arguments); }, s.version = '1.1', s.queue = [], u = t.createElement(n), u.async = !0, u.src = '//static.ads-twitter.com/uwt.js', a = t.getElementsByTagName(n)[0], a.parentNode.insertBefore(u, a)); }(window, document, 'script'));
  twq('init', 'nw1qv');
  /* jshint ignore:end */

  pageMeta = getPageMeta();
  ruid = getRUID();
  pvid = getPVID();

  function sendPageview() {
    tracking.fbq_wrap('track', 'PageView');
    twq('track', 'PageView');
  }

  function sendPageviewManually() {
    pvid = getPVID();
    pageMeta = getPageMeta();

    sendPageview();
  }
  tracking.sendPageviewManually = sendPageviewManually;

  function sendPageUnload() {
    sendToEventClient({ eventName: 'page_unload' });
  }

  function sendNavigationTimingMetrics() {
    // Only track performance in supporting browsers.
    if (!(window.performance && window.performance.timing)) return;

    // If the window hasn't loaded, run this function after the `load` event.
    if (document.readyState !== 'complete') {
      window.addEventListener('load', sendNavigationTimingMetrics);
      return;
    }

  }

  sendPageview();
  sendNavigationTimingMetrics();
  $window.on('beforeunload', sendPageUnload);
  tracking.lazy_bind = function () {
    if (tracking && tracking.find) {
      tracking.find('.trackable_lazy').attachDisplayTracker().attachClickTracker().attachEventTracker().end();
      $('.trackable_lazy').removeClass('trackable_lazy');
    }
  }
  $document.ajaxComplete((event, jqXHR, ajaxOptions) => {
    tracking.lazy_bind();
  });
};


/* Custom selectors for your convenience.   */
/* Use as $("img:below-the-fold").something() or */
/* $("img").filter(":below-the-fold").something() which is faster */

$.extend($.expr.pseudos, {
  'below-the-fold': function (a) {
    return tracking.belowthefold(a, { threshold: 0 });
  },
  'above-the-top': function (a) {
    return !tracking.belowthefold(a, { threshold: 0 });
  },
  'right-of-screen': function (a) {
    return tracking.rightoffold(a, { threshold: 0 });
  },
  'left-of-screen': function (a) {
    return !tracking.rightoffold(a, { threshold: 0 });
  },
  'in-viewport': function (a) {
    return tracking.inviewport(a, { threshold: 0 });
  },
  /* Maintain BC for couple of versions. */
  'above-the-fold': function (a) {
    return !tracking.belowthefold(a, { threshold: 0 });
  },
  'right-of-fold': function (a) {
    return tracking.rightoffold(a, { threshold: 0 });
  },
  'left-of-fold': function (a) {
    return !tracking.rightoffold(a, { threshold: 0 });
  },
});

$.extend(tracking, {
  currentUser() {
    return (Ridi.globals.userId === null) ? '' : Ridi.globals.userId;
  },
  currentDevice() {
    if (Ridi.globals.isMobile) {
      return 'Mobile';
    } else if (Ridi.globals.isPaper) {
      return 'Paper';
    }
    return 'Pc';
  },
  currentUserEmail() {
    return Ridi.globals.userEmail;
  },
});

function DefaultTrackingHandler() {
  const handler = this;
  $.extend(this, {
    handleDisplay(trackable) {
      // do nothing
    },
    handleClick(trackable) {
      // do nothing
    },
    handleEvent(trackable) {
      // do nothing
    },
  });
}

function EventClientHandler() {
  DefaultTrackingHandler.apply(this, arguments);
  $.extend(this, {
    handleDisplay(trackable) {
      const type = trackable.getType();
      const ga4Params = trackable.getGA4Params();
      const params = {
        section: trackable.getSection(),
        section_full: trackable.getSectionFull(),
        obj_id: trackable.getObjectId(),
        idx: trackable.getIndex(),
        is_last: trackable.isLastItem(),
        rcmd_id: trackable.getRcmdId(),
      };
      if (type !== 'signUp') {
        sendToEventClient({ eventName: 'display', params });
      }
      if (!isEmptyObject(ga4Params)) {
        sendToEventClient({ eventName: 'view', ga4Params });
      }
    },
    handleClick(trackable) {
      const ga4Params = trackable.getGA4Params();
      if (!isEmptyObject(ga4Params)) {
        sendToEventClient({ eventName: 'select', ga4Params });
        return;
      }
      const params = {
        section: trackable.getSection(),
        section_full: trackable.getSectionFull(),
        obj_id: trackable.getObjectId(),
        idx: trackable.getIndex(),
        rcmd_id: trackable.getRcmdId(),
      };
      sendToEventClient({ eventName: 'click', params });
    },
    handleEvent() {
    },
  });
}

function GoogleAnalyticsHandler() {
  DefaultTrackingHandler.apply(this, arguments);
  $.extend(this, {
    handleDisplay(trackable) {
    },
    handleClick(trackable) {
    },
    handleEvent(trackable) {
      let type = trackable.getType(),
        tags = trackable.getTags(),
        section_full = trackable.getSectionFull();

      if (type === 'purchase' && !isCookieExists(tags.t_id) && !isOldTransaction(tags.t_id)) {
        gaAggregatePurchaseTracking(trackable);
      }
    },
  });
}

function CresendoHandler() {
  const handler = this;
  DefaultTrackingHandler.apply(this, arguments);
  $.extend(this, {
    handleDisplay(trackable) { },
    handleClick(trackable) {
      let type = trackable.getType(),
        section = trackable.getSection(),
        obj_id = trackable.getObjectId();
      if (type === 'cart' || type === 'wishlist') {
        const b_ids = [];
        if (section === 'series_list') {
          $('.js_series_book_list.selected').each(function () {
            b_ids.push($(this).data('id'));
          });
        } else {
          b_ids.push(obj_id);
        }

        let cresendo_code = '';
        if (type === 'cart') {
          cresendo_code = (tracking.currentDevice() === 'Pc') ? '1' : '6';
        } else {
          cresendo_code = (tracking.currentDevice() === 'Pc') ? '12' : '10';
        }
        csf('event', cresendo_code, b_ids.join('|'), '');
      }
    },
    handleEvent(trackable) {
      let type = trackable.getType(),
        section = trackable.getSection(),
        obj_id = trackable.getObjectId(),
        tags = trackable.getTags();
      let cresendo_code = '';
      if (type === 'purchase') {
        if (section === 'receipt_total') {
          cresendo_code = (tracking.currentDevice() === 'Pc') ? '2' : '7';
          csf('event', cresendo_code, obj_id, tags.price);
        } else if (section === 'cash') {
          cresendo_code = (tracking.currentDevice() === 'Pc') ? '4' : '9';
          csf('event', cresendo_code, obj_id, tags.price);
        }
      } else if (type === 'signUp') {
        cresendo_code = (tracking.currentDevice() === 'Pc') ? '0' : '5';
        tracking.fbq_wrap('track', 'CompleteRegistration');
        csf('event', cresendo_code);
      } else if (type === 'product') {
        tracking.fbq_wrap('track', 'ViewContent');
      }
    },
  });
}

function Trackable(element) {
  const $element = $(element);
  const trackable = this;

  trackable.element = element;
  trackable.href = $(element).attr('href');
  trackable.track_params = {
    send_display: true,
    send_click: true,
    is_last_item: false,
    section: 'unknown',
    genre: { kor: 'etc', eng: 'etc' },
    rcmd_id: '',
  }; // default values
  // frontends/web/ridibooks의 이벤트와 동일한 이벤트 처리를 위한 인터페이스 (리팩토링 시 위 인터페이스로 통일)
  trackable.track_ga4_params = {};

  $.extend(true, trackable.track_params, $element.data('track-params'));
  $.extend(true, trackable.track_ga4_params, $element.data('track-ga4-params'));
  trackable.handler_types = ($element.data('track-type') || 'eventClient,ga').split(',');
  if (trackable.track_params.tags && trackable.track_params.tags.is_last_item) {
    trackable.track_params.is_last_item = trackable.track_params.tags.is_last_item;
  }
  if (trackable.track_params.tags && trackable.track_params.tags.genre) {
    trackable.track_params.genre.eng = trackable.track_params.tags.genre;
  }
  if (trackable.track_params.tags && trackable.track_params.tags.genre_kor) {
    trackable.track_params.genre.kor = trackable.track_params.tags.genre_kor;
  }
  if (trackable.track_params.tags && trackable.track_params.tags.rcmd_id) {
    trackable.track_params.rcmd_id = trackable.track_params.tags.rcmd_id;
  } else {
    trackable.track_params.rcmd_id = '';
  }

  let section_all = [
    pageMeta.device,
    pageMeta.page,
    trackable.track_params.section,
  ];

  if (
    !pageMeta.page.startsWith('home-')
    && !pageMeta.page.startsWith('personalized-')
    && !pageMeta.page.startsWith('new_releases-')
  ) {
    section_all.push(trackable.track_params.genre.eng);
  }

  // if A/B Test is running add variance version to section info
  if (pageMeta.href.includes('utmxid')) {
    const variance = 'abt' in pageMeta.query_params ? pageMeta.query_params['abt'] : 'original';
    section_all.push(variance);
  }
  trackable.track_params.section_full = section_all.join('.');

  $.extend(this, {
    getType() {
      return trackable.track_params.type;
    },
    getSectionFull() {
      return trackable.track_params.section_full;
    },
    getSection() {
      return trackable.track_params.section;
    },
    getObjectId() {
      return trackable.track_params.obj_id;
    },
    getIndex() {
      return trackable.track_params.idx;
    },
    getTags() {
      return trackable.track_params.tags;
    },
    getGenre() {
      return trackable.track_params.genre;
    },
    getRcmdId() {
      return trackable.track_params.rcmd_id;
    },
    isDisplayEnabled() {
      return trackable.track_params.send_display;
    },
    isClickEnabled() {
      return trackable.track_params.send_click;
    },
    isLastItem() {
      return trackable.track_params.is_last_item;
    },

    getTrackingHandlers() {
      const handlers = $.map(trackable.handler_types, type => {
        if (type === 'ga') return new GoogleAnalyticsHandler();
        else if (type === 'eventClient') return new EventClientHandler();
        else if (type === 'echo') return new CresendoHandler();
        return new DefaultTrackingHandler();
      });
      return handlers;
    },

    getGA4Params() {
      return trackable.track_ga4_params;
    },

    event() {
      const handlers = trackable.getTrackingHandlers();
      $.each(handlers, (idx, handler) => {
        handler.handleEvent(trackable);
      });
    },

    display() {
      if (!trackable.isDisplayEnabled()) return;

      const handlers = trackable.getTrackingHandlers();
      $.each(handlers, (idx, handler) => {
        handler.handleDisplay(trackable);
      });
    },

    click() {
      if (!this.isClickEnabled()) return;

      const handlers = trackable.getTrackingHandlers();
      $.each(handlers, (idx, handler) => {
        handler.handleClick(trackable);
      });
    },
  });
}
/*
 * trackable 요소 click/display 이벤트 관련 함수
 */
$.extend(tracking, {
  find(selector) {
    if (!selector) selector = '.trackable';
    var trackables = {
      _settings: {
        threshold: 0,
        container: window,
        params_attr: 'track-params',
        ga4_params_attr: 'track-ga4-params',
        type_attr: 'track-type',
        skip_invisible: true,
      },
      settings(options) {
        if (options) {
          $.extend(trackables._settings, options);
        }
        return trackables;
      },
      elements() {
        return $(selector).filter(function () {
          this.track_params = $(this).data(trackables._settings.params_attr);
          this.track_ga4_params = $(this).data(trackables._settings.ga4_params_attr);
          if (this.track_params || this.track_ga4_params) {
            this.track_type = $(this).data(trackables._settings.type_attr);
            if (!this.track_type) this.track_type = 'eventClient';
            return true;
          }
          return false;
        });
      },
      end() {
        return tracking;
      },
      attachDisplayTracker() {
        const settings = trackables._settings;
        const $elements = trackables.elements();
        const $container = (settings.container === undefined || settings.container === window) ? $window : $(settings.container);

        function update() {
          $elements.each(function () {
            const elem = this;
            const $elem = $(elem);
            if (settings.skip_invisible && !$elem.is(':visible')) {
              return;
            }

            if (document.readyState !== 'complete') {
              return;
            }

            if (tracking.inviewport(elem, settings)) {
              $elem.trigger('track-display');
            }
          });
        }

        if (Ridi.globals.isMobile) {
          $container.on('touchend', update);
          $('.js_top_banner_swipe').on('DOMSubtreeModified', update);
        } else {
          $container.on('scroll', update);
        }
        $window.on('resize', update);
        $window.on('load', update);
        $window.on('click', update);
        $('.js_track_trigger_mouseenter').on('mouseenter', update);
        $container.on('update', update);
        $elements.one('track-display', function () {
          tracking.display(this);
        });
        return trackables;
      },
      attachClickTracker() {
        trackables.elements().one('click', function (event) {
          tracking.click(this, event);
        });
        return trackables;
      },
      attachEventTracker() {
        trackables.elements().each(function () {
          tracking.event(this);
        });
        return trackables;
      },
      display() {
        trackables.elements().each(function () {
          tracking.display(this);
        });
        return trackables;
      },
      click() {
        trackables.elements().each(function () {
          tracking.click(this);
        });
        return trackables;
      },
    };
    return trackables;
  },

  belowthefold(element, settings) {
    let fold;

    if (settings.container === undefined || settings.container === window) {
      fold = $window.height() + $window.scrollTop();
    } else {
      fold = $(settings.container).offset().top + $(settings.container).height();
    }

    return fold <= $(element).offset().top - settings.threshold;
  },

  rightoffold(element, settings) {
    let fold;

    if (settings.container === undefined || settings.container === window) {
      fold = $window.width() + $window.scrollLeft();
    } else {
      fold = $(settings.container).offset().left + $(settings.container).width();
    }

    return fold <= $(element).offset().left - settings.threshold;
  },

  abovethetop(element, settings) {
    let fold;

    if (settings.container === undefined || settings.container === window) {
      fold = $window.scrollTop();
    } else {
      fold = $(settings.container).offset().top;
    }

    return fold >= $(element).offset().top + settings.threshold + $(element).height();
  },

  leftofbegin(element, settings) {
    let fold;

    if (settings.container === undefined || settings.container === window) {
      fold = $window.scrollLeft();
    } else {
      fold = $(settings.container).offset().left;
    }

    return fold >= $(element).offset().left + settings.threshold + $(element).width();
  },

  inviewport(element, settings) {
    return !tracking.rightoffold(element, settings) && !tracking.leftofbegin(element, settings) && !tracking.belowthefold(element, settings) && !tracking.abovethetop(element, settings);
  },

  event(element) {
    const trackable = new Trackable(element);
    trackable.event();

    element.event_tracked = true;
  },

  display(element) {
    if (element.display_tracked) return;

    const trackable = new Trackable(element);
    trackable.display();

    element.display_tracked = true;
  },

  click(element) {
    if (element.click_tracked) return;

    const trackable = new Trackable(element);
    trackable.click();

    element.click_tracked = true;
  },
});

function isCookieExists(t_id) {
  let cname = `TID_${t_id}=`,
    cookies = document.cookie.split(';');

  return cookies.some(ck => ck.trim().toString().indexOf(cname) === 0);
}

function setCookie(t_id) {
  const d = new Date();
  d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000));

  document.cookie = `TID_${t_id}=${getTransactionTimestampFromTid(t_id)}; expires=${d.toGMTString()};domain=.ridibooks.com;`;
}

function isOldTransaction(t_id) {
  let transactionTimestamp = getTransactionTimestampFromTid(t_id),
    currentTime = new Date().getTime(),
    minutes = Math.round((currentTime - transactionTimestamp) / 1000 / 60);

  return minutes > 30;
}

function getTransactionTimestampFromTid(t_id) {
  const t_id_date = `${t_id.substr(0, 4)}-${t_id.substr(4, 2)}-${t_id.substr(6, 2)}`;
  const t_id_time = parseInt(t_id.substr(8, 5));
  const d = new Date(t_id_date);
  const t_id_datetime = d.getTime() + (t_id_time * 1000) + (d.getTimezoneOffset() * 60 * 1000);

  return t_id_datetime;
}

let purchased_prods_by_series = {},
  purchase_action_data = {},
  listed_all_products = false,
  set_purchase_action = false;

function gaAggregatePurchaseTracking(trackable) {
  let tags = trackable.getTags(),
    section = trackable.getSection(),
    section_full = trackable.getSectionFull(),
    rep_id = tags.rep_id || trackable.getObjectId(),
    rep_title = tags.rep_title || tags.name;
  if (section === 'receipt_book') {
    const book_price = tags.price > 0 ? parseInt(tags.price) : 0;
    const book_quantity = tags.price > 0 ? parseInt(tags.quantity) : 0;
    if (rep_id in purchased_prods_by_series) {
      purchased_prods_by_series[rep_id].price += book_price;
      purchased_prods_by_series[rep_id].quantity += book_quantity;
    } else {
      purchased_prods_by_series[rep_id] = {
        id: rep_id,
        price: book_price,
        quantity: book_quantity,
        name: rep_title,
        brand: tags.brand,
        category: tags.category
      };
    }
    if (tags.is_last_item) {
      $.each(purchased_prods_by_series, (id, values) => {
        if (values.quantity === 0) {
          values.price = 0;
        } else {
          values.price = Math.round(values.price / values.quantity * 100) / 100;
        }
        sendToEventClient({ eventName: 'purchase_book', params: values });
        tracking.fbq_wrap('track', 'Purchase', {
          value: values.price,
          currency: 'KRW',
          content_ids: values.id
        });
      });
      listed_all_products = true;
    }
  } else if (section === 'receipt_total') {
    purchase_action_data = { id: tags.t_id, revenue: tags.price };
    set_purchase_action = true;
  }
  if (listed_all_products && set_purchase_action) {
    sendToEventClient({ eventName: 'transaction', params: purchase_action_data });
    setCookie(purchase_action_data.id);
  }
}

function getPageMeta() {
  const originUrl = window.location.href;
  const splitUrl = originUrl.split('?');
  const queryString = splitUrl.length > 1 ? splitUrl[1] : '';
  const pathname = window.location.pathname;
  let path = `${pathname}?${queryString}`;
  const device = tracking.currentDevice();
  let page = '';
  const queryParams = {};

  if (queryString !== '') {
    queryString.split('&').forEach(v => {
      queryParams[v.split('=')[0]] = v.split('=')[1];
    });
  }

  if (pathname === '/') {
    const genre = 'genre' in queryParams ? queryParams['genre'] : 'etc';
    page = `home-${genre}`;
  } else if (pathname.startsWith('/new-releases/')) {
    page = `new_releases-${pathname.split('/')[2]}`;
  } else if (pathname.startsWith('/personalized-recommendation/')) {
    page = `personalized-${pathname.split('/')[2]}`;
  } else if (pathname === '/books/') {
    page = 'detail';
  } else if (pathname.startsWith('/category/')) {
    page = 'category';
  } else if (pathname.startsWith('/curation-room/')) {
    page = `curation-${pathname.split('/')[2]}`;
  } else if (pathname.startsWith('/special-room/')) {
    page = `special-${pathname.split('/')[2]}`;
  } else if (pathname === '/wishlist/') {
    page = 'wishlist';
  } else if (pathname === '/search/') {
    page = 'search';
    if ($('.js_empty_result_wrapper').length > 0) {
      path = `/search/empty?${queryString}`;
    }
  } else if (pathname === '/order/finished_book' || pathname === '/order/checkout/finished') {
    page = 'purchase_book';
  } else {
    page = pathname.split('/')[1];
  }

  return {
    device,
    page,
    query_params: queryParams,
    path: encodeURIComponent(path),
    href: encodeURIComponent(originUrl),
    referrer: encodeURIComponent(document.referrer),
  };
}

function isInSameSequence() {
  const href = document.location.href.split('?');
  const referrer = document.referrer.split('?');

  if (href[0] !== referrer[0]) {
    return false;
  } else if (href[1] === undefined && referrer[1] === undefined) {
    return true;
  } else if (href[1] === undefined || referrer[1] === undefined) {
    return false;
  } else {
    return [href[1], referrer[1]]
      .map(param_str => param_str.split('&').filter(param => !param.startsWith('page=')).sort().join('&'))
      .reduce((href_params, referrer_params) => href_params === referrer_params)
  }
}

function setAndGetNewUID(uid_type, expires = 1) {
  const uid = generateUID(uid_type);

  setUID(uid_type, uid, expires);
}

function setUID(uid_type, uid, expires) {
  $.cookie(uid_type, uid, { expires: expires, path: '/', domain: '.ridibooks.com' });
  return uid;
}

function generateUID(uid_type) {
  let d = new Date().getTime();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  return `xxxxxxxx-${uid_type}-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, c => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

const ruidAgeInDays = 20 * 365;
function getRUID() {
  let ruid = $.cookie('ruid');

  if ('ruid' in pageMeta.query_params) {
    ruid = setUID('ruid', pageMeta.query_params['ruid'], ruidAgeInDays);
  }

  if (typeof ruid === 'undefined' || ruid === 'undefined') {
    return setAndGetNewUID('ruid', ruidAgeInDays)
  }

  return ruid;
}

function getPVID() {
  const pvid = (isInSameSequence()) ? $.cookie('pvid') : setAndGetNewUID('pvid', 1);

  return (typeof pvid === 'undefined') ? setAndGetNewUID('pvid', 1) : pvid;
}

tracking.init();

export default tracking;




// WEBPACK FOOTER //
// ./common/tracking.lib.js